import React, { useState } from "react";
import EyeCloseIcon from "../../assets/Icons/EyeCloseIcon";

function TextField({
  type = "text",
  // value = "",
  placeholder = "Enter text",
  // onChange,
  className = "",
  isPassword = false,
  errorMessage = "",
  multiline = false,
  register = () => ({}),
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`w-full h-full ${className} flex flex-col gap-1`}>
      <div className={`flex items-center gap-2 rounded-md bg-[#FFFFFF]`}>
        {multiline ? (
          <textarea
            // value={value}
            placeholder={placeholder}
            // onChange={onChange}
            {...rest}
            {...register}
            className="
            w-full h-full
            px-[14px] py-[12px] 
            gap-[10px] 
            rounded-md
            bg-[#FFFFFF] 
            focus:outline-none focus:border-blue-500
            placeholder-slate-600
            placeholder:text-[14px] 
            placeholder:font-[400]
          "
          />
        ) : (
          <input
            type={isPassword && !showPassword ? "password" : type}
            // value={value}
            placeholder={placeholder}
            // onChange={onChange}
            {...rest}
            {...register}
            className="
            w-full h-full
            px-[14px] py-[12px] 
            gap-[10px] 
            rounded-md
            bg-[#FFFFFF] 
            focus:outline-none focus:border-blue-500
            placeholder-slate-600
            placeholder:text-[14px] 
            placeholder:font-[400]
            text-sm
          "
          />
        )}
        {isPassword && !multiline && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="flex items-center z-10 mr-2"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            <EyeCloseIcon />
          </button>
        )}
      </div>
      {errorMessage && (
        <p className="text-red-400 text-left ml-1 text-sm">{errorMessage}</p>
      )}
    </div>
  );
}

export default TextField;
